export default "__VITE_ASSET__JHM7OjUZ__"